import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const CompaniesPageCover = () => (
  <StaticQuery
    query={graphql`
      query {
        storiesCover: file(
          relativePath: { eq: "covers/companies_cover@2x.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1600) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={(data) => {
      return (
        <div className="w-100 stories-wrapper">
          <Img
            className="stories-cover"
            fluid={data.storiesCover.childImageSharp.fluid}
          />
          <div className="stories-info max-1100">
            <h1>
              <span className="text-green">企業を探す</span>
            </h1>
            <p>気になる企業の働き方をチェック！</p>
          </div>
        </div>
      );
    }}
  />
);

export default CompaniesPageCover;
